const sample = [
    {
        question:"Which planet is closest to the Sun?",
        options:["Venus","Mercury","Earth","Mars"],
        correct:"Mercury",
        type:"mcq",
        marks:2
    },
    {
        question:"Which data structure organizes items in a First-In, First-Out (FIFO) manner?",
        options:["Stack","Queue","Tree","Graph"],
        correct:"Queue",
        type:"mcq",
        marks:2
    },
    {
        question:"Which of the following is primarily used for structuring web pages?",
        options:["Python","JAVA","HTML","C++"],
        correct:"HTML",
        type:"mcq",
        marks:2
    },
    {
        question:"Which chemical symbol stands for Gold?",
        options:["Au","Gd","Ag","Pt"],
        correct:"Au",
        type:"mcq",
        marks:2
    },
    {
        question:"Which of these processes is not typically involved in refining petroleum?",
        options:["Fractional distillation","Cracking","Polymerization","Filtration"],
        correct:"Filtration",
        type:"mcq",
        marks:2
    },
    {
        question:"What is the value of 12 + 28?",
        options:[],
        correct:"40",
        type:"number",
        marks:2
    },
    {
        question:"How many states are there in the United States?",
        options:[],
        correct:"50",
        type:"number",
        marks:2
    },
    {
        question:"In which year was the Declaration of Independence signed?",
        options:[],
        correct:"1776",
        type:"number",
        marks:2
    },
    {
        question:"What is the value of pi rounded to the nearest integer?",
        options:[],
        correct:"3",
        type:"number",
        marks:2
    },
    {
        question:"If a car travels at 60 mph for 2 hours, how many miles does it travel?",
        options:[],
        correct:"120",
        type:"number",
        marks:2
    }
];

export default sample;